module.exports = __webpack_public_path__ + "img/new-newsletter-image.fbf2605c.png";